import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

import {AVAILABILITY_REQUEST} from '../../../utils/constants'

import { formSubmit, formUpdate, formStepInc } from '../../../actions/requestFormActions'
import { Button } from '../../utils/Button'
import { Card } from '../../utils/Card'

const connected = connect(store => {
  return {
    currentStep: store.requestForm.step,
    submitting: store.requestForm.submitting,
    error: store.requestForm.error,
    isAuthenticated: store.session.isAuthenticated,
    availabilityRequest: store.availabilityRequestForm
  }
})
export class RequestFormStepButtons extends Component {
  nextStep() {
    this.props.dispatch(formStepInc())
  }

  handleSubmit() {
    const availabilityRequest = this.props.availabilityRequest
    if (availabilityRequest && availabilityRequest.uuid) {
      this.props.dispatch(formUpdate(true))
    } else {
      this.props.dispatch(formSubmit())
    }
  }
  get lastStep() {
    return this.props.isAuthenticated ? 3 : 4
  }

  render() {
    const { currentStep, submitting } = this.props

    return (
      <>
        {this.props.error && Array.isArray(this.props.error) && (
          <Card color="red" className="mb-6">
            <div className="text-2xl font-semibold mb-3">This request can not be created!</div>
            {this.props.error.map(error =>
              <div key={error} className="text-lg">
                {AVAILABILITY_REQUEST.errors[error] || error}
              </div>
            )}
          </Card>
        )}
        <div>
          {currentStep !== this.lastStep && (
            <Button className="w-full" color="darkGreen" onClick={() => this.nextStep()} disabled={this.props.disabled}>
              Next Step
              <FontAwesomeIcon icon={faChevronRight} className="ml-4" />
            </Button>
          )}
          {currentStep === this.lastStep && (
            <Button
              className="w-full"
              color="darkGreen"
              disabled={this.props.disabled || submitting}
              loading={submitting}
              onClick={() => this.handleSubmit()}
            >
              Submit Request
            </Button>
          )}
        </div>
      </>
    )
  }
}
export default connected(RequestFormStepButtons)
